export const ADD_ACTIVE_TOAST = 'ADD_ACTIVE_TOAST'
export const REMOVE_ACTIVE_TOAST = 'REMOVE_ACTIVE_TOAST'

export const SET_LOADING_TOAST = 'CREATE_LOADING_TOAST'

export const SET_LOADING_STATUS = 'SET_LOADING_STATUS'
export const SET_LOADING_TOAST_MSG = 'SET_LOADING_TOAST_MSG'

export const SET_ORIGINAL_PLUGIN = 'SET_ORIGINAL_PLUGIN'
